import React from 'react';

import Icon from '@mui/icons-material/Clear';
import { SvgIconProps } from '@mui/material/SvgIcon';

const ClearIcon = ({ color, style, ...props }: SvgIconProps) => <Icon style={{ color, ...style }} {...props} />;

export default ClearIcon;
